<template>
  <div class="cq-btn">
    <div class= "behind-btn">
      <b-button class="btn" :class="{'btn-primary': !inverse, 'btn-white': inverse, 'middle' : centerfloatbtn}"> <slot /> </b-button>
    </div>
  </div>
</template>

<script>
export default {
  // name: 'cq-btn',
  props: {
    inverse: {
      default: false
    },
    centerfloatbtn: {
      default: false
    }
  },

  data() {
    return {
      something: true
    }
  }
}
</script>

<style scoped>
.btn{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display:inline-block;
  width: auto;
  position: relative;
  border: 4px solid transparent;
  border-radius: 30px;
  border-color: transparent !important;
  background-clip: padding-box;
  padding: 5px 30px;
  border-image-slice: 1;
  top: 0;
  left: 20px;
  margin-left: -19px;
  font-family: 'Seravek-Medium';
  font-size: 20px;
  cursor: pointer;
}
.btn-primary {
  background-color: var(--primary-color) !important;
  color: var(--secondary-color);
}
.btn-white {
  background-color: var(--secondary-color) ;
  color: var(--primary-color) !important;
}

@media only screen and (max-width: 992px){
  .btn{
    padding: 5px 20px !important;
    font-size: 16px;
  }

  .behind-btn{
    height: 42px !important;
  }
}

@media only screen and (min-width: 992px){
  .cq-btn{
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .btn-white {
    margin-bottom: 30px;
  }
}

.btn-primary:active, .btn-primary:hover{
  background-color: var(--primary-color-active) !important;
}

.btn-white:active, .btn-white:hover{
  background-color: var(--secondary-color-active) !important;
}

.btn:focus{
  box-shadow: none !important;
}

.behind-btn{
  display: inline-block;
  width: auto !important;
  min-width: auto;
  border-radius: 30px;
  background-image: linear-gradient(to right, var(--tertiary-color), var(--secondary-color) 50%, var(--tertiary-color)); /* Standard syntax (must be last) */
  padding-right: 20px;
  width: 125px;
  height: 48px;
  position: relative;
}

.middle{
  text-align: center;
}

</style>
